import Content from '../components/icon-switching-content/ss-wrap.svelte'
import ShowCalendar from '../components/show-calendar.svelte'

export default {
	init() {
		let $contentWrap = $('#sc_inner');

		if ($contentWrap.length) {
			new Content({
				target: $contentWrap[0],
				props: $contentWrap.data(),
			})
		}
	},
	finalize() {
		showCalendar();
	},
}

function showCalendar() {
	let $calendar = $('#show_calendar')
	if ($calendar.length) {
		new ShowCalendar({
			target: $calendar[0],
			props: $calendar.data(),
		})
	}
}
